import React from 'react';

export default function Progreso({ pasos, actual, onIr }) {
  return (
    <div data-testid="tienda-progreso">
      <div className="mb-2 flex items-center justify-between text-xs">
        <span className="font-medium uppercase tracking-wider text-[#C9A962]">{pasos[actual].titulo}</span>
        <span className="text-zinc-500">Paso {actual + 1} de {pasos.length}</span>
      </div>
      <div className="flex gap-1.5">
        {pasos.map((p, i) => (
          <button
            key={p.id}
            type="button"
            disabled={i >= actual}
            onClick={() => onIr(i)}
            title={p.titulo}
            aria-label={p.titulo}
            className={`flex h-1.5 min-h-0 flex-1 items-center justify-center rounded-full transition-colors ${i < actual ? 'cursor-pointer bg-[#C9A962] hover:bg-[#D4B872]' : i === actual ? 'bg-[#C9A962]/70' : 'bg-zinc-800'}`}
            data-testid={`tienda-progreso-${i}`}
          />
        ))}
      </div>
    </div>
  );
}
